var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "circle-users" },
    _vm._l(_vm.getOrderedUsers(), function (item) {
      return _c(
        "div",
        {
          directives: [
            {
              name: "tippy",
              rawName: "v-tippy",
              value: { followCursor: true, placement: "bottom-end" },
              expression: "{ followCursor: true, placement: 'bottom-end' }",
            },
          ],
          key: item.user._id,
          staticClass: "circle",
          class: { selected: item.user._id === _vm.value },
          attrs: { content: item.user.name + " (" + item.user.status + ")" },
          on: {
            click: function ($event) {
              return _vm.changeUser(item.user)
            },
          },
        },
        [
          item.badge || item.badge === 0
            ? _c("span", { staticClass: "badge" }, [_vm._v(_vm._s(item.badge))])
            : _vm._e(),
          _vm._v(" "),
          _c("AgentAvatar", {
            attrs: { userID: item.user._id, size: 40, "single-char": "" },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }